module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0140.jpg?v=1c8f3cff";